import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import { AuthInit } from './modules/auth'

const App = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY!}
      scriptProps={{
        defer: true,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
      <ToastContainer />
    </GoogleReCaptchaProvider>
  )
}

export { App }
